import type { IconSvgObject } from './types';

const SolarPanel01Icon: IconSvgObject = [
  ["path", { d: "M20.7192 16C21.3698 16 21.8472 15.3886 21.6894 14.7575L19.1894 4.75746C19.0781 4.3123 18.6781 4 18.2192 4H5.78078C5.32191 4 4.92193 4.3123 4.81063 4.75746L2.31063 14.7575C2.15285 15.3886 2.63021 16 3.28078 16H20.7192Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 16V20M12 20H15M12 20H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 10H20", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M13.9567 4L16 15.83M10.1585 4.25445L8 16", stroke: "currentColor", strokeWidth: "1.5", key: "3" }]
];

export default SolarPanel01Icon;
